import React, { useState, useRef } from 'react';
import '../styles/NextGenCloud.css';

const NextGenCloud: React.FC = () => {
  const [isPlaying, setIsPlaying] = useState(false);
  const videoRef = useRef<HTMLVideoElement>(null);

  const togglePlayPause = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  return (
    <section className="nextgen-cloud-section">
      <div className="nextgen-cloud-container">
        <div className="nextgen-cloud-media">
          <video 
            ref={videoRef}
            className="nextgen-cloud-video"
            muted
            loop
            autoPlay
          >
            <source src="https://www.marketing.webmobrilinc.com/wp-content/themes/hello-elementor/portfolio/images/videos/welcome-3.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <button 
            className="nextgen-cloud-play-button"
            onClick={togglePlayPause}
            aria-label={isPlaying ? "Pause video" : "Play video"}
          >
            {isPlaying ? (
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 4H6V20H10V4Z" fill="black" />
                <path d="M18 4H14V20H18V4Z" fill="black" />
              </svg>
            ) : (
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 5V19L19 12L8 5Z" fill="black" />
              </svg>
            )}
          </button>
        </div>
        
        <div className="nextgen-cloud-content">
          {/* <div className="background-pattern"></div> */}
          <p className="nextgen-cloud-text">
            Leveraging both <span className="text-highlight">server-based</span> and <span className="text-highlight">serverless architectures</span>, real-time streaming analytics, edge-native IoT frameworks, AI/ML pipelines, and blockchain composability, we deliver <span className="text-bold">scalable, secure solutions</span> for sectors like fintech, autonomous mobility, and decentralized applications.
          </p>
          
          <div className="nextgen-cloud-pills">
            <span className="nextgen-cloud-pill">Serverless</span>
            <span className="nextgen-cloud-pill">IoT</span>
            <span className="nextgen-cloud-pill">AI/ML</span>
            <span className="nextgen-cloud-pill">Blockchain</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NextGenCloud; 